import axios from 'axios';
import util from '@/libs/util.js';
import { Message } from 'element-ui';
import { httpCodeMap, SINGLE_TOKEN_KEY, SINGLE_UUID_KEY } from '@/maps/common';
import store from '@/store/index';
import router from '@/router'; // 导入 Vue Router 实例

const getBaseURL = () => {
  let url = '/';
  if (process.env.NODE_ENV === 'development') {
    url = process.env.VUE_APP_API_MODULE;
  } else {
    url = process.env.VUE_APP_SERVER + process.env.VUE_APP_API_MODULE;
  }
  console.log(url);
  return url;
};

const showErrorMessage = message => {
  Message({
    message,
    type: 'error',
    duration: 2 * 1000,
  });
};

const handleAuthFailure = () => {
  util.cookies.remove(SINGLE_TOKEN_KEY, { path: '/', domain: '.mg.xyz' });
  util.cookies.remove(SINGLE_UUID_KEY, { path: '/', domain: '.mg.xyz' });
  store.dispatch('user/setToken', null);
  store.dispatch('user/setUserInfo', null);
  store.dispatch('system/setIsLogin', false);

  if (util.isMobile()) {
    router.replace('/mobile/home');
  } else {
    router.replace('/home');
  }
};

const clearUser = () => {
  util.clearUser();
};

const getHttpErrorMessage = status => {
  const errorMessages = {
    400: '错误请求',
    401: '未授权，请重新登录',
    403: '拒绝访问',
    404: '请求错误,未找到该资源',
    405: '请求方法未允许',
    408: '请求超时',
    500: '服务器端出错',
    501: '网络未实现',
    502: '网络错误',
    503: '服务不可用',
    504: '网络超时',
    505: 'http版本不支持该请求',
  };

  return errorMessages[status] || `连接错误${status}`;
};

const service = axios.create({
  baseURL: getBaseURL(), // api 的 base_url  process.env.BASE_API
  timeout: 30000, // request timeout
});

// Request interceptor
service.interceptors.request.use(
  config => {
    // 这里只能用util.cookies.get的方式获取token
    const token = util.cookies.get(SINGLE_TOKEN_KEY);
    console.log(config.url, 'config.url');
    
    if (token || config.url !== '/user/send/code') {
      if (config.url !== '/rfab/stationvip/order/queryWithSign' && config.url !== '/pay/h5/prePayOrder') {
        // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
        config.headers.Authorization = token;
      }
    }
    config.headers.appId = store.getters['system/getAppID'];
    return config;
  },
  error => {
    Promise.reject(error);
  },
);
console.log('111111111');

// Response interceptor
service.interceptors.response.use(
  response => {
    const config = response.config;
    /** 这里的逻辑是确保只有正确的返回才会走到then里面，所有错误的结果都在catch中处理 */
    const { code, msg, message } = response.data;
    // 200 正常请求(只要code===200，说明接口数据没有异常，否则找后端协调)
    if (+code === httpCodeMap.success) {
      return response.data;
    } else {
      // 接口内部错误都统一在这里提示错误
      let { showMsg = true, auth = false } = config.headers;
      if ((msg || message) && code !== 4010) {
        if (showMsg) {
          showErrorMessage(msg || message);
        }
      }
      if (code === '401') {
        clearUser();
        if (auth) {
          if (util.isMobile()) {
            router.replace('/mobile/home');
          } else {
            router.replace('/home');
          }
        }
      }
      return Promise.reject(response.data);
    }
  },
  error => {
    let errorMessage = '连接到服务器失败';

    if (error?.response) {
      errorMessage = getHttpErrorMessage(error.response.status);

      // Handle 401 authentication failure
      if (error.response.status === 401) {
        handleAuthFailure();
      }
    }

    showErrorMessage(errorMessage);
    return Promise.reject(error);
  },
);

export default service;
